import currentAccount, { setCurrentAccount } from './currentAccount';
import { appContainer } from '../../contexts/app';
import { fromImmutable, toImmutable, validate } from '../hooks';

export default app => {
  const service = app.service('api/accounts');
  const cardService = app.service('api/accounts/cards');
  const sessionService = app.service('api/sessions');
  const CurrentAccountRecord = currentAccount(
    service,
    cardService,
    sessionService
  );

  const validateAccount = validate({
    name: 'Organization name is required',
    plan_id: 'Plan type is required',
    owner_id: 'Plan owner is required'
  });

  appContainer.CurrentAccountRecord = CurrentAccountRecord;
  app.set('CurrentAccountRecord', CurrentAccountRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      // create: [], We never create an account from here
      update: [fromImmutable, validateAccount],
      patch: [fromImmutable, validateAccount],
      remove: []
    },

    after: {
      all: [toImmutable(CurrentAccountRecord)],
      find: [],
      get: [setCurrentAccount],
      create: [setCurrentAccount],
      update: [setCurrentAccount],
      patch: [setCurrentAccount],
      remove: []
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/currentAccount/currentAccount-setup.js